import { Button, FlexCrate, Modal, Text } from '@perch-labs/shrike';
import styled from 'styled-components';

export const StyledModalHeader = styled.div`
  background: ${props => props.theme.colors.content.accent1}
    url('/images/solar/welcome-header.svg') no-repeat right bottom -9px;
  height: 130px;
  div {
    border-bottom: none;
    padding: 24px;
  }
`;

export const StyledModalHeaderBackground = styled.div`
  background: ${props => props.theme.colors.background.primaryInverse}
    url('/images/solar/sponsored-solar-header.svg') repeat left -9px;
  height: 250px;
  div {
    height: 250px;
    border-bottom: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 24px;
  }
`;

export const StyledModalHeaderBlankTitle = styled(Modal.Header).attrs({
  title: '',
})``;

export const StyledSponsoredSolarHeader = styled.div`
  font-weight: 800;
  font-size: 32px;
  text-transform: uppercase;
`;

export const SponsoredSolarWelcome = styled.div`
  color: #f9f3e8;
  background-color: #004037;
`;
export const StyledTextMain = styled(Text).attrs({
  margin: {
    bottom: `16px`,
  },
})``;

export const StyledFlexCrate = styled(FlexCrate).attrs({
  margin: {
    bottom: `12px`,
  },
})``;

export const StyledListItemText = styled(Text).attrs({
  textStyle: 'paragraph500',
  margin: {
    left: `16px`,
  },
})``;

export const StyledLogo = styled.span`
  line-height: 1.5;
`;

export const StyledButtonMain = styled(Button).attrs({
  margin: { top: '16px' },
  fullWidth: true,
})``;
